// LICENSE_CODE ZON
'use strict';/*jslint ts:true, react:true*/
import React, {useContext} from 'react';
import {img_url} from '../ui/img_url';
import cn from 'classnames';
import {Settings_context} from '../settings_ctx';
// @ts-ignore
import {open_link} from '../install_util.js';
import {use_download} from '../shared/use_download';
import {Button} from '../../../shared/button';
import {Editor} from '../../../shared/editor/editor';
import styles from './dont_take_banner.module.less';

export const Dont_take_banner = ()=>{
    const {theme} = useContext(Settings_context);
    const {download_br} = use_download();
    const on_download = ()=>{
        download_br({cb: ()=>{
          // waiting for iframe to start actial downloading
          setTimeout(()=>{
              // absolute link for holabrowser.com
              window.location.href =
                  'https://hola.org/after_download?s=install&browser=1';
          }, 1000);
        }});
    };
    return <div className={styles.dont_take_block}>
      <img src={img_url('hola2023/stars.svg')} width={362} height={104}
        alt="stars" className="lazyload"/>
      <h3>Don't just take our word for it</h3>
      <p className={cn(theme.u3)}>Hola is trusted by more than 263 million
        people around the globe!</p>
      <div className={styles.reviews}>
        <div className={styles.one_review}>
          <div className={styles.review_platform}
            title={'hola on chrome webstore'}
            onClick={()=>open_link('chrome')}>
            <img src={img_url('hola2023/review_chrome_webstore.svg')}
              alt="chrome" className="lazyload"/>
            <p className={cn(theme.p3, theme.med)}><img alt="stars"
              className="lazyload"
              src={img_url('hola2023/review_chrome_webstore_stars.svg')}/>
              4.9 <span>|</span> 360,000+ reviews
            </p>
          </div>
          <div className={styles.review_text}>
            <p className={cn(theme.p2)}>
              "OMG, it works. I love it! I tried like 20 other VPN's (...)
              This one worked like a charm".
            </p>
            <div className={styles.name_and_pl}>
              <p className={theme.u4}>Sany Sanichar</p>
              <p className={theme.u4}>Chrome Web Store</p>
            </div>
          </div>
        </div>
        <div className={cn([styles.one_review, styles.hidden_for_middle])}>
          <div className={styles.review_platform}
            title={'hola on amazon'}
            onClick={()=>open_link('amazon')}>
            <img src={img_url('hola2023/review_amazon.svg')} alt="amazon"
              className="lazyload"/>
            <p className={cn(theme.p3, theme.med)}><img alt="stars"
              className="lazyload"
              src={img_url('hola2023/review_amazon_stars.svg')}/>
              3.6 <span>|</span> 8,100+ reviews
            </p>
          </div>
          <div className={styles.review_text}>
            <p className={cn(theme.p2)}>
              "This one is one of the Best VPNs I've ever used to this day".
            </p>
            <div className={styles.name_and_pl}>
              <p className={theme.u4}>Jason A Kane</p>
              <p className={theme.u4}>Amazon Store</p>
            </div>
          </div>
        </div>
        <div className={styles.one_review}>
          <div className={styles.review_platform}
            title={'hola on opera addons'}
            onClick={()=>open_link('opera')}>
            <img src={img_url('hola2023/review_opera.svg')} alt="opera"
              className="lazyload"/>
            <p className={cn(theme.p3, theme.med)}><img alt="stars"
              className="lazyload"
              src={img_url('hola2023/review_opera_stars.svg')}/>
              4.1 <span>|</span> 2,300+ reviews
            </p>
          </div>
          <div className={styles.review_text}>
            <p className={cn(theme.p2)}>
              "Perfect VPN, it even works with Disney+ to access region-only
              content. Thanks!".
            </p>
            <div className={styles.name_and_pl}>
              <p className={theme.u4}>santyrios514</p>
              <p className={theme.u4}>Opera addons</p>
            </div>
          </div>
        </div>
      </div>
      <Button on_click={on_download} caption="Get Hola Browser"
        color="black2023" size="lg" arrow txt_colored />
    </div>;
};

interface i_dont_take_banner_editor_props {
    value: unknown;
    on_change: (new_val: unknown)=>void;
}

export const Dont_take_banner_editor = (
{value, on_change}: i_dont_take_banner_editor_props)=>{
    return <Editor value={value} on_change={on_change} editors={[]} />;
};
